import { render, staticRenderFns } from "./published-ticket-item.vue?vue&type=template&id=1def087c&scoped=true"
import script from "./published-ticket-item.vue?vue&type=script&lang=js"
export * from "./published-ticket-item.vue?vue&type=script&lang=js"
import style0 from "./published-ticket-item.vue?vue&type=style&index=0&id=1def087c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def087c",
  null
  
)

export default component.exports